<template>
  <v-card-text>
    <v-row class="pt-10 pb-8" justify="center">
      <span class="text-333333 w-700 font-18">ประเมินสภาพผู้ป่วย INHOMESSS</span>
    </v-row>
      <!-- 3.1 -->
    <v-form ref="form3">
      <v-row class="card-border">
        <v-col cols="12" md="4" xl="4" lg="4" :class="phone || tablet ? 'px-0 card-border-title-phone' : 'pr-0 card-border-title'">
          <v-card class="card-none-shadow pa-3">
            <v-row>
              <v-col cols="12">
                <span class="w-700 font-16 text-333333">I: immobility</span>
                <br />
                <span class="w-500 font-16 text-333333">
                  สามารถดูแลตัวเองได้ หรือต้องอาศัยผู้อื่นในการดูแลในการทำกิจวัตรประจำวันพื้นฐาน การเคลื่อนไหวกิจวัตรประจำวัน ADL
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="8" xl="8" lg="8" class="pa-0">
          <v-card class="card-none-shadow py-6 px-3">
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="py-2 w-500 font-16 text-333333">
                  {{immobility.self_help.title}}
                </span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="immobility.self_help.status == '3'">
                  ระบุ {{immobility.self_help.detail}}
                </span>
              </v-col>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="py-2 w-500 font-16 text-333333">
                  {{immobility.balance_problem.title}}
                </span>
              </v-col>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="py-2 w-500 font-16 text-333333">
                  {{immobility.bedridden_patient.title}}
                </span>
              </v-col>
              <v-col cols="12" class="pb-0 pl-4" v-if="immobility.other_detail !== ''">
                <span class="py-2 w-500 font-16 text-333333">
                  อื่นๆ ระบุ {{immobility.other_detail}}
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="card-border">
        <v-col cols="12" md="4" xl="4" lg="4" :class="phone || tablet ? 'px-0 card-border-title-phone' : 'pr-0 card-border-title'">
          <v-card class="card-none-shadow pa-3">
            <v-row>
              <v-col cols="12">
                <span class="w-700 font-16 text-333333">N: Nutrition</span>
                <br />
                <span class="w-500 font-16 text-333333">
                  อาหาร ภาวะโภชนาการ
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="8" xl="8" lg="8" class="pa-0">
          <v-card class="card-none-shadow py-6 px-3">
            <v-row>
              <v-col cols="12" class="pb-0 pl-4 d-flex d-flex-row">
                <v-row no-gutters>
                  <span class="py-2 pr-3 w-600 font-16 text-333333">น้ำหนัก</span>
                  <span class="py-2 w-500 font-16 text-333333">{{nutrition.weight || '-'}}</span>
                  <span class="py-2 w-600 font-16 text-333333 px-3">กก.</span>
                </v-row>
                <v-row no-gutters>
                  <span class="py-2 pr-3 w-600 font-16 text-333333">ส่วนสูง</span>
                  <span class="py-2 w-500 font-16 text-333333">{{nutrition.height || '-'}}</span>
                  <span class="py-2 w-600 font-16 text-333333 px-3">ซม.</span>
                </v-row>
                <v-row no-gutters>
                  <span class="py-2 pr-3 w-600 font-16 text-333333">BMI</span>
                  <span class="py-2 w-500 font-16 text-333333">{{nutrition.BMI || '-'}}</span>
                  <span class="py-2 w-600 font-16 text-333333 px-3">กก./ม<sup>2</sup></span>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="py-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">ลักษณะของอาหารที่รับประทาน</span>
                <span class="py-2 w-500 font-16 text-333333">{{nutrition.characteristics_food_eaten.title || '-'}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.characteristics_food_eaten.status == '4' || nutrition.characteristics_food_eaten.status == '5'">ระบุ {{nutrition.characteristics_food_eaten.detail}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">รสชาติอาหารที่ชอบ (ใส่ได้มากกว่า 1 หัวข้อ)</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.taste_favorite_food.sweet.status == '1'">{{nutrition.taste_favorite_food.sweet.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.taste_favorite_food.oily.status == '1'">{{nutrition.taste_favorite_food.oily.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.taste_favorite_food.salty.status == '1'">{{nutrition.taste_favorite_food.salty.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.taste_favorite_food.spicy.status == '1'">{{nutrition.taste_favorite_food.spicy.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.taste_favorite_food.sour.status == '1'">{{nutrition.taste_favorite_food.sour.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.taste_favorite_food.other.status == '1'">{{nutrition.taste_favorite_food.other.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.taste_favorite_food.other.status == '1'">ระบุ {{nutrition.taste_favorite_food.other.detail}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">อาหารที่เหมาะสมกับโรค</span>
                <span class="py-2 w-500 font-16 text-333333">{{nutrition.food_appropriate_disease.title || '-'}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.food_appropriate_disease.status == '2'">ระบุ {{nutrition.food_appropriate_disease.detail}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4 d-flex d-flex-row">
                <v-row no-gutters>
                  <v-col cols="12" xl="4" lg="4" md="4" sm="4">
                    <span class="pt-2 w-600 font-16 text-333333 pr-3">จำนวนมื้อต่อวัน</span>
                    <span class="pt-2 px-3 w-500 font-16 text-333333">{{nutrition.number_food_day || '-'}}</span>
                  </v-col>
                  <v-col cols="12" xl="8" lg="8" md="8" sm="8">
                    <span class="pt-2 px-3 w-600 font-16 text-333333">ผู้ดูแลเรื่องอาหาร</span>
                    <span class="pt-2 px-3 w-500 font-16 text-333333">{{nutrition.food_handler || '-'}}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">ที่มาของอาหาร (ใส่ได้มากกว่า 1 หัวข้อ)</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.food_origin.homemade.status == '1'">{{nutrition.food_origin.homemade.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.food_origin.deli.status == '1'">{{nutrition.food_origin.deli.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.food_origin.frozen_food.status == '1'">{{nutrition.food_origin.frozen_food.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.food_origin.other.status == '1'">{{nutrition.food_origin.other.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.food_origin.other.status == '1'">ระบุ {{nutrition.food_origin.other.detail}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">การรับประทานอาหาร</span>
                <span class="py-2 w-500 font-16 text-333333">{{nutrition.eating.title || '-'}}</span><span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.food_origin.status == '4'">ระบุ {{nutrition.food_origin.detail}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">เหล้า/แอลกอฮอล์</span>
                <span class="py-2 w-500 font-16 text-333333">{{nutrition.alcohol_drink.title || '-'}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.alcohol_drink.status == '2'">ปริมาณต่อวัน {{nutrition.alcohol_drink.volume_per_day}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">บุหรี่/ยาเส้น</span>
                <span class="py-2 w-500 font-16 text-333333">{{nutrition.cigarettes.title || '-'}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.cigarettes.status == '2'">ปริมาณต่อวัน {{nutrition.cigarettes.volume_per_day}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">เครื่องดื่มที่ดื่มเป็นประจำ (ใส่ได้มากกว่า 1 หัวข้อ)</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.regular_drink.coffee.status == '1'">{{nutrition.regular_drink.coffee.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.regular_drink.tea.status == '1'">{{nutrition.regular_drink.tea.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.regular_drink.soft_drink.status == '1'">{{nutrition.regular_drink.soft_drink.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.regular_drink.energy_drink.status == '1'">{{nutrition.regular_drink.energy_drink.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.regular_drink.other.status == '1'">{{nutrition.regular_drink.other.title}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="nutrition.regular_drink.other.status == '1'">ระบุ {{nutrition.regular_drink.other.detail}}</span>
              </v-col>
            </v-row>
            <v-row v-if="nutrition.other_detail !== ''">
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">อื่น ๆ</span>
                <span class="py-2 w-500 font-16 text-333333">ระบุ {{nutrition.other_detail}}</span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="card-border">
        <v-col cols="12" md="4" xl="4" lg="4" :class="phone || tablet ? 'px-0 card-border-title-phone' : 'pr-0 card-border-title'">
          <v-card class="card-none-shadow pa-3">
            <v-row>
              <v-col cols="12">
                <span class="w-700 font-16 text-333333">H: Home Environment</span>
                <br />
                <span class="w-500 font-16 text-333333">
                  สภาพแวดล้อมในบ้าน/รอบบ้าน
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="8" xl="8" lg="8" class="pa-0">
          <v-card class="card-none-shadow py-6 px-3">
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">ความสะอาดในบ้าน</span>
                <span class="py-2 w-500 font-16 text-333333">{{home_environment.clean_house.title || '-'}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">ความเป็นระเบียบเรียบร้อยในบ้าน</span>
                <span class="py-2 w-500 font-16 text-333333">{{home_environment.orderliness_house.title || '-'}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">แสงสว่างในบ้าน</span>
                <span class="py-2 w-500 font-16 text-333333">{{home_environment.light_of_house.title || '-'}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">อากาศภายในบ้าน</span>
                <span class="py-2 w-500 font-16 text-333333">{{home_environment.indoor_air.title || '-'}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">ความปลอดภัยในบ้าน</span>
                <span class="py-2 w-500 font-16 text-333333">{{home_environment.security.title || '-'}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="home_environment.security.status == '2'">ระบุ {{home_environment.security.detail}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">บริเวณรอบบ้าน (ใส่ได้มากกว่า 1 หัวข้อ)</span>
                <span class="py-2 pr-3 w-500 font-16 text-333333" v-if="home_environment.area_around_house.waterlogged.title == '' && home_environment.area_around_house.overgrown.title == '' && home_environment.area_around_house.other.title == ''">-</span>
                <span v-if="home_environment.area_around_house.waterlogged.status == '1'" class="py-2 pr-3 w-500 font-16 text-333333">{{home_environment.area_around_house.waterlogged.title}}</span>
                <span v-if="home_environment.area_around_house.overgrown.status == '1'" class="py-2 pr-3 w-500 font-16 text-333333">{{home_environment.area_around_house.overgrown.title}}</span>
                <span v-if="home_environment.area_around_house.other.status == '1'" class="py-2 pr-3 w-500 font-16 text-333333">{{home_environment.area_around_house.other.title}}</span>
                <span v-if="home_environment.area_around_house.other.status == '1'" class="py-2 pl-3 w-500 font-16 text-333333">ระบุ {{home_environment.area_around_house.other.detail}}</span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="card-border">
        <v-col cols="12" md="4" xl="4" lg="4" :class="phone || tablet ? 'px-0 card-border-title-phone' : 'pr-0 card-border-title'">
          <v-card class="card-none-shadow pa-3">
            <v-row>
              <v-col cols="12">
                <span class="w-700 font-16 text-333333">O: Other people</span>
                <br />
                <span class="w-500 font-16 text-333333">
                  สมาชิกในครอบครัว
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="8" xl="8" lg="8" :class="phone || tablet ? 'px-0' : 'pl-0'">
          <v-card class="card-none-shadow py-6 px-3">
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">ความสัมพันธ์ของบุคคลในครอบครัว</span>
                <span class="py-2 w-500 font-16 text-333333">{{other_people.relation_family_member.title || '-'}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">ความช่วยเหลือกันในครอบครัว</span>
                <span class="py-2 w-500 font-16 text-333333">{{other_people.family_help.title || '-'}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">เมื่อผู้ป่วยมีภาวะฉุกเฉินเจ็บป่วยผู้นำส่ง รพ.คือ</span>
                <span class="py-2 w-500 font-16 text-333333">{{other_people.patient_emergencythe_dispatcher.title || '-'}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="other_people.patient_emergencythe_dispatcher.status == '3'">ระบุ {{other_people.patient_emergencythe_dispatcher.detail}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">ผู้ดูแล Care giver มีภาวะเสี่ยงด้านสุขภาพกายสุขภาพจิต</span>
                <span class="py-2 w-500 font-16 text-333333">{{other_people.caregiver_risk_health.title || '-'}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4 d-flex d-flex-row">
                <v-row no-gutters>
                  <v-col cols="12" xl="3" lg="4" md="4" sm="4">
                    <span class="pr-3 w-600 font-16 text-333333">ผู้ตัดสินใจการรักษา รพ.คือ</span>
                    <span class="py-2 w-500 font-16 text-333333">{{other_people.treatment_decision_maker.title || '-'}}</span>
                  </v-col>
                  <v-col cols="12" xl="8" lg="8" md="8" sm="8" v-if="other_people.treatment_decision_maker.status == '2'">
                    <span class="py-2 px-3 w-500 font-16 text-333333">ระบุ</span>
                    <span class="py-2 px-3 w-500 font-16 text-333333">ชื่อ-สกุล {{other_people.treatment_decision_maker.name || '-'}}</span>
                    <span class="py-2 px-3 w-500 font-16 text-333333">เบอร์โทร {{splitDatMobile() || '-'}}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <!-- 3.2 -->
      <v-row class="card-border">
        <v-col cols="12" md="4" xl="4" lg="4" :class="phone || tablet ? 'px-0 card-border-title-phone' : 'pr-0 card-border-title'">
          <v-card class="card-none-shadow pa-3">
            <v-row>
              <v-col cols="12">
                <span class="w-700 font-16 text-333333">M: Medication</span>
                <br />
                <span class="w-500 font-16 text-333333">
                  การใช้ยา
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="8" xl="8" lg="8" class="pa-0">
          <v-card class="card-none-shadow py-6 px-3">
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">การบริหารยา</span>
                <span class="py-2 w-500 font-16 text-333333">{{medication.administration_medicine.title || '-'}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">ได้รับยา</span>
                <span class="py-2 w-500 font-16 text-333333">{{medication.get_medicine.title || '-'}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">ยาประจำ</span>
                <span class="py-2 w-500 font-16 text-333333">{{medication.regular_medicine || '-'}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4 d-flex d-flex-row">
                <v-row no-gutters>
                  <v-col cols="12" xl="4" lg="4" md="4" sm="4">
                    <span class="pt-2 w-600 font-16 text-333333 pr-3">อาหารเสริม</span>
                    <span class="pt-2 px-3 w-500 font-16 text-333333">{{medication.supplementary_food || '-'}}</span>
                  </v-col>
                  <v-col cols="12" xl="8" lg="8" md="8" sm="8">
                    <span class="pt-2 pr-3 w-600 font-16 text-333333">ยาสมุนไพร</span>
                    <span class="pt-2 pr-3 w-500 font-16 text-333333">{{medication.herbal_medicine || '-'}}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">อื่น ๆ </span>
                <span class="py-2 w-500 font-16 text-333333" v-if="medication.other !== ''">ระบุ {{medication.other}}</span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="card-border">
        <v-col cols="12" md="4" xl="4" lg="4" :class="phone || tablet ? 'px-0 card-border-title-phone' : 'pr-0 card-border-title'">
          <v-card class="card-none-shadow pa-3">
            <v-row>
              <v-col cols="12">
                <span class="w-700 font-16 text-333333">E: Examination</span>
                <br />
                <span class="w-500 font-16 text-333333">
                  การตรวจร่างกาย
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="8" xl="8" lg="8" class="pa-0 pl-1">
          <v-card class="card-none-shadow py-6 px-3">
            <v-row>
              <v-col cols="12" class="py-0 pl-4 d-flex d-flex-row">
                <v-row no-gutters class="pb-3">
                  <span class="pt-2 w-600 font-16 text-333333 pr-3">V/S T</span>
                  <span class="pt-2 w-500 font-16 text-333333 pr-3">{{examination.V_S.T.value_1 || '-'}}</span>
                  <span class="pt-2 w-600 font-16 text-333333 pr-3">C</span>
                </v-row>
                <v-row no-gutters class="pb-3">
                  <span class="pt-2 w-600 font-16 text-333333 pr-3">BP (1)</span>
                  <span class="pt-2 w-500 font-16 text-333333 pr-3">{{examination.V_S.BP.value_1 || '-'}}</span>
                  <span class="pt-2 w-500 font-16 text-333333 pr-3">/</span>
                  <span class="pt-2 w-500 font-16 text-333333 pr-3">{{examination.V_S.BP.value_2 || '-'}}</span>
                  <span class="pt-2 w-600 font-16 text-333333 pr-3">mm.Hg</span>
                </v-row>
                <v-row no-gutters class="pb-3">
                  <span class="pt-2 w-600 font-16 text-333333 pr-3">RR</span>
                  <span class="pt-2 w-500 font-16 text-333333 pr-3">{{examination.V_S.RR.value_1 || '-'}}</span>
                  <span class="pt-2 w-600 font-16 text-333333 pr-3">/min.</span>
                </v-row>
                <v-row no-gutters class="pb-3">
                  <span class="pt-2 w-600 font-16 text-333333 pr-3">PR</span>
                  <span class="pt-2 w-500 font-16 text-333333 pr-3">{{examination.V_S.PR.value_1 || '-'}}</span>
                  <span class="pt-2 w-600 font-16 text-333333 pr-3">/min.</span>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pl-1 pt-0 d-flex d-flex-row">
                <span class="pt-2 w-600 font-16 text-333333 px-3">PE</span>
                <span class="pt-2 w-500 font-16 text-333333 pr-3">{{examination.V_S.PE.value_1 || '-'}}</span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="card-border">
        <v-col cols="12" md="4" xl="4" lg="4" :class="phone || tablet ? 'px-0 card-border-title-phone' : 'pr-0 card-border-title'">
          <v-card class="card-none-shadow pa-3">
            <v-row>
              <v-col cols="12">
                <span class="w-700 font-16 text-333333">S: Safety</span>
                <br />
                <span class="w-500 font-16 text-333333">
                  ความปลอดภัย
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="8" xl="8" lg="8" class="pa-2">
          <v-card class="card-none-shadow py-6 px-3">
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="pr-3 w-600 font-16 text-333333">พลัดตกหกล้ม</span>
                <span class="py-2 w-500 font-16 text-333333">{{safety.fell_down_safety.title || '-'}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-0">
                <span class="pr-3 w-600 font-16 text-333333">ห้องน้ำ ห้องครัว บันได พื้นบ้าน อุปกรณ์ไฟฟ้า</span>
                <span class="py-2 w-500 font-16 text-333333">{{safety.indoor_safety.title || '-'}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="safety.indoor_safety.status == '2'">ระบุ {{safety.indoor_safety.detail}}</span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="card-border">
        <v-col cols="12" md="4" xl="4" lg="4" :class="phone || tablet ? 'px-0 card-border-title-phone' : 'pr-0 card-border-title'">
          <v-card class="card-none-shadow pa-3">
            <v-row>
              <v-col cols="12">
                <span class="w-700 font-16 text-333333">S: Spiritual Health</span>
                <br />
                <span class="w-500 font-16 text-333333">
                  สุขภาวะทางจิตวิญญาณ
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="8" xl="8" lg="8" class="pa-0">
          <v-card class="card-none-shadow py-6 px-3">
            <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">ความเชื่อ/เครื่องยืดเหนี่ยวจิตใจ</span>
                <span class="py-2 w-500 font-16 text-333333">{{spiritual_health.spiritual || '-'}}</span>
              </v-col>
            </v-row>
             <v-row>
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">ความเชื่อต่อการเจ็บป่วย</span>
                <span class="py-2 w-500 font-16 text-333333">{{spiritual_health.belief.title || '-'}}</span>
                <span class="py-2 pl-3 w-500 font-16 text-333333" v-if="spiritual_health.belief.status == '3'">ระบุ {{spiritual_health.belief.detail}}</span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="card-border card-border-end">
        <v-col cols="12" md="4" xl="4" lg="4" :class="phone || tablet ? 'px-0 card-border-title-phone' : 'pr-0 card-border-title'">
          <v-card class="card-none-shadow pa-3">
            <v-row>
              <v-col cols="12">
                <span class="w-700 font-16 text-333333">S: Service</span>
                <br />
                <span class="w-500 font-16 text-333333">
                  แหล่งให้บริการสุขภาพใกล้บ้าน
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" md="8" xl="8" lg="8" class="pa-0">
          <v-card class="card-none-shadow py-6 px-3">
            <v-row v-if="local_service.hospital.status == '0' && local_service.local_hospital.status == '0' &&local_service.clinic.status == '0' &&local_service.other_service.status == '0'">
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">-</span>
              </v-col>
            </v-row>
            <v-row v-if="local_service.hospital.status == '1'">
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">{{local_service.hospital.title || '-'}}</span>
                <span class="py-2 w-500 font-16 text-333333">{{local_service.hospital.detail}}</span>
              </v-col>
            </v-row>
            <v-row v-if="local_service.local_hospital.status == '1'">
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">{{local_service.local_hospital.title || '-'}}</span>
                <span class="py-2 w-500 font-16 text-333333">{{local_service.local_hospital.detail}}</span>
              </v-col>
            </v-row>
            <v-row v-if="local_service.clinic.status == '1'">
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">{{local_service.clinic.title || '-'}}</span>
                <span class="py-2 w-500 font-16 text-333333">{{local_service.clinic.detail}}</span>
              </v-col>
            </v-row>
            <v-row v-if="local_service.other_service.status == '1'">
              <v-col cols="12" class="pb-0 pl-4">
                <span class="pr-3 w-600 font-16 text-333333">{{local_service.other_service.title || '-'}}</span>
                <span class="py-2 w-500 font-16 text-333333">ระบุ {{local_service.other_service.detail}}</span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="px-0">
          <span class="pr-3 w-700 font-16 text-333333">กิจกรรมการออกกำลังกาย/การเคลื่อนไหวร่างกาย</span>
          <span class="w-500 font-16 text-333333">{{exercise_activity || '-'}}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="py-0 px-0 d-flex d-flex-row">
          <v-row no-gutters>
            <span class="pt-2 w-700 font-16 text-333333">การนอนหลับ</span>
              <v-row no-gutters class="pl-5">
                <v-col cols="12" class="d-flex d-flex-row">
                  <span class="pt-2 w-500 font-16 text-333333 px-3">นอนหลับวันละ</span>
                  <span class="pt-2 w-500 font-16 text-333333 px-3">{{sleepy.hours_sleep || '-'}}</span>
                  <span class="pt-2 w-500 font-16 text-333333 px-3">ชั่วโมง</span>
                </v-col>
                <v-col cols="12" class="d-flex d-flex-row">
                  <span class="pt-2 w-500 font-16 text-333333 px-3">{{sleepy.sleep_problem.title}}</span>
                  <span class="pt-2 w-500 font-16 text-333333 px-3" v-if="sleepy.sleep_problem.status == '2'">ระบุ {{sleepy.sleep_problem.detail}}</span>
                </v-col>
              </v-row>      
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-card-text>
</template>

<script>
export default {
  data() {
    return {
      immobility: {
        self_help: {
          status: '',
          title: '',
          detail: ''
        },
        balance_problem: {
          status: '',
          title: ''
        },
        bedridden_patient: {
          status: '',
          title: ''
        },
        other_detail: ''
      },
      nutrition: {
        weight: '',
        height: '',
        BMI: '',
        characteristics_food_eaten: {
          status: '',
          title: '',
          detail: ''
        },
        taste_favorite_food: {
          sweet: {
            status: '0',
            title: 'หวาน',
          },
          oily: {
            status: '0',
            title: 'มัน',
          },
          salty: {
            status: '0',
            title: 'เค็ม',
          },
          spicy: {
            status: '0',
            title: 'เผ็ด',
          },
          sour: {
            status: '0',
            title: 'เปรี้ยว',
          },
          other: {
            status: '0',
            title: 'อื่น ๆ',
            detail: ''
          }
        },
        food_appropriate_disease: {
          status: '',
          title: '',
          detail: ''
        },
        number_food_day: 0,
        food_handler: '',
        food_origin: {
          homemade: {
            status: '0',
            title: 'ปรุงเอง',
          },
          deli: {
            status: '0',
            title: 'อาหารสำเร็จรูป',
          },
          frozen_food: {
            status: '0',
            title: 'อาหารแช่แข็ง',
          },
          other: {
            status: '0',
            title: 'อื่น ๆ',
            detail: ''
          }
        },
        eating: {
          status: '',
          title: '',
        },
        alcohol_drink: {
          status: '',
          title: '',
          volume_per_day: ''
        },
        cigarettes: {
          status: '',
          title: '',
          volume_per_day: ''
        },
        regular_drink: {
          coffee: {
            status: '0',
            title: 'กาแฟ',
          },
          tea: {
            status: '0',
            title: 'ชา',
          },
          soft_drink: {
            status: '0',
            title: 'น้ำอัดลม',
          },
          energy_drink: {
            status: '0',
            title: 'เครื่องดื่มชูกำลัง',
          },
          other: {
            status: '0',
            title: 'อื่น ๆ',
            detail: ''
          }
        },
        other_detail: ''
      },
      home_environment: {
        clean_house: {
          status: '',
          title: ''
        }, //true = 1, false = 0
        orderliness_house: {
          status: '',
          title: ''
        },
        light_of_house: {
          status: '',
          title: ''
        },
        indoor_air: {
          status: '',
          title: ''
        },
        security: {
          status: '',
          title: '',
          detail: ''
        },
        area_around_house: {
          waterlogged: {
            status: '0',
            title: '',
          },
          overgrown: {
            status: '0',
            title: '',
          },
          other: {
            status: '1',
            title: '',
            detail: ''
          }
        },
      },
      other_people: {
        relation_family_member: {
          status: '',
          title: ''
        },
        family_help: {
          status: '',
          title: ''
        },
        patient_emergencythe_dispatcher: {
          status: '',
          title: '',
          detail: ''
        },
        caregiver_risk_health: {
          status: '',
          title: ''
        },
        treatment_decision_maker: {
          status: '',
          title: '',
          name: '',
          mobile: ''
        }
      },
      medication: {
        administration_medicine: {
          status: '',
          title: ''
        },
        get_medicine: {
          status: '',
          title: ''
        },
        regular_medicine: '',
        supplementary_food: '',
        herbal_medicine: '',
        other: ''
      },
      examination: {
        V_S: {
          T: {
            value_1: ''
          },
          BP: {
            value_1: '',
            value_2: ''
          },
          RR: {
            value_1: ''
          },
          PR: {
            value_1: ''
          },
          PE: {
            value_1: ''
          }
        }
      },
      safety: {
        fell_down_safety: {
          status: '',
          title: ''
        },
        indoor_safety: {
          status: '',
          title: '',
          detail: ''
        }
      },
      spiritual_health: {
        spiritual: '',
        belief: {
          status: '',
          title: '',
          detail: ''
        }
      },
      local_service: {
        hospital: {
          status: '0',
          title: 'โรงพยาบาล',
          detail:''
        },
        local_hospital: {
          status: '0',
          title: '',
          detail:''
        },
        clinic: {
          status: '0',
          title: '',
          detail:''
        },
        other_service: {
          status: '0',
          title: '',
          detail:''
        }
      },
      exercise_activity: '',
      sleepy: {
        hours_sleep: '',
        sleep_problem: {
          status: '',
          title: '',
          detail: ''
        }
      },
      service_status: [false,false,false,false],
      service_status_result: false,
      rules_checkbox: [(v) => !!v || "กรุณาเลือกข้อมูล"],
      rules_checkbox_service: [(v) => v != 0 || "กรุณาเลือกข้อมูล"],
      rules_checkbox2: [
        // (v) => !!v || "กรุณาเลือกข้อมูล",
        (v) => this.rules_other(v) || "กรุณาเลือกข้อมูล"
      ],
      rules_detail: [(v) => !!v || "กรุณาระบุข้อมูล"]
    }
  },
  computed: {
    display_vuetify() {
      return this.$vuetify.breakpoint.name
    },
    x_mobile: {
      get: function () {
        if (this.$vuetify.breakpoint.width <= 820) {
          return true;
        } else {
          return false;
        }
      },
      set: function (newValue) {
        this.nav = newValue;
      }
    },
    phone() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (this.$vuetify.breakpoint.width <= 820) {
        return true;
      } else {
        return false;
      }
    },
  },
  async created() {
    
  },
  methods: {
    splitDatMobile() {
      if(this.other_people.treatment_decision_maker.mobile.length == 10) {
        return this.other_people.treatment_decision_maker.mobile.substring(0,3)+'-'+this.other_people.treatment_decision_maker.mobile.substring(3,6)+'-'+this.other_people.treatment_decision_maker.mobile.substring(6,10)
      } else if(this.other_people.treatment_decision_maker.mobile.length == 9) {
        return this.other_people.treatment_decision_maker.mobile.substring(0,1)+'-'+this.other_people.treatment_decision_maker.mobile.substring(1,5)+'-'+this.other_people.treatment_decision_maker.mobile.substring(5,9)
      }
    },
    openPage(inhomesss) {
      console.log('res inhomesss', inhomesss);

      this.immobility = {
        self_help: {
          status: 'immobility' in inhomesss && 'self_help' in inhomesss.immobility && 'status' in inhomesss.immobility.self_help && inhomesss.immobility.self_help.status !== '' &&  inhomesss.immobility.self_help.status !== null && inhomesss.immobility.self_help.status !== undefined ? inhomesss.immobility.self_help.status : '',
          title: 'immobility' in inhomesss && 'self_help' in inhomesss.immobility && 'title' in inhomesss.immobility.self_help && inhomesss.immobility.self_help.title !== '' &&  inhomesss.immobility.self_help.title !== null && inhomesss.immobility.self_help.title !== undefined ? inhomesss.immobility.self_help.title : '',
          detail: 'immobility' in inhomesss && 'self_help' in inhomesss.immobility && 'detail' in inhomesss.immobility.self_help && inhomesss.immobility.self_help.detail !== '' &&  inhomesss.immobility.self_help.detail !== null && inhomesss.immobility.self_help.detail !== undefined ? inhomesss.immobility.self_help.detail : '',
        },
        balance_problem: {
          status: 'immobility' in inhomesss && 'balance_problem' in inhomesss.immobility && 'status' in inhomesss.immobility.balance_problem && inhomesss.immobility.balance_problem.status !== '' &&  inhomesss.immobility.balance_problem.status !== null && inhomesss.immobility.balance_problem.status !== undefined ? inhomesss.immobility.balance_problem.status : '',
          title: 'immobility' in inhomesss && 'balance_problem' in inhomesss.immobility && 'title' in inhomesss.immobility.balance_problem && inhomesss.immobility.balance_problem.title !== '' &&  inhomesss.immobility.balance_problem.title !== null && inhomesss.immobility.balance_problem.title !== undefined ? inhomesss.immobility.balance_problem.title : '',
        },
        bedridden_patient: {
          status: 'immobility' in inhomesss && 'bedridden_patient' in inhomesss.immobility && 'status' in inhomesss.immobility.bedridden_patient && inhomesss.immobility.bedridden_patient.status !== '' &&  inhomesss.immobility.bedridden_patient.status !== null && inhomesss.immobility.bedridden_patient.status !== undefined ? inhomesss.immobility.bedridden_patient.status : '',
          title: 'immobility' in inhomesss && 'bedridden_patient' in inhomesss.immobility && 'title' in inhomesss.immobility.bedridden_patient && inhomesss.immobility.bedridden_patient.title !== '' &&  inhomesss.immobility.bedridden_patient.title !== null && inhomesss.immobility.bedridden_patient.title !== undefined ? inhomesss.immobility.bedridden_patient.title : '',
        },
        other_detail: 'immobility' in inhomesss && 'other_detail' in inhomesss.immobility && inhomesss.immobility.other_detail !== '' && inhomesss.immobility.other_detail !== null && inhomesss.immobility.other_detail !== undefined ? inhomesss.immobility.other_detail : ''
      }

      this.nutrition = {
        weight: 'nutrition' in inhomesss && 'weight' in inhomesss.nutrition && inhomesss.nutrition.weight !== '' && inhomesss.nutrition.weight !== null && inhomesss.nutrition.weight !== undefined ? inhomesss.nutrition.weight : '',
        height: 'nutrition' in inhomesss && 'height' in inhomesss.nutrition && inhomesss.nutrition.height !== '' && inhomesss.nutrition.height !== null && inhomesss.nutrition.height !== undefined ? inhomesss.nutrition.height : '',
        BMI: 'nutrition' in inhomesss && 'BMI' in inhomesss.nutrition && inhomesss.nutrition.BMI !== '' && inhomesss.nutrition.BMI !== null && inhomesss.nutrition.BMI !== undefined ? inhomesss.nutrition.BMI : '',
        characteristics_food_eaten: {
          status: 'nutrition' in inhomesss && 'characteristics_food_eaten' in inhomesss.nutrition && 'status' in inhomesss.nutrition.characteristics_food_eaten && inhomesss.nutrition.characteristics_food_eaten.status !== '' && inhomesss.nutrition.characteristics_food_eaten.status !== null && inhomesss.nutrition.characteristics_food_eaten.status !== undefined ? inhomesss.nutrition.characteristics_food_eaten.status : '',
          title: 'nutrition' in inhomesss && 'characteristics_food_eaten' in inhomesss.nutrition && 'title' in inhomesss.nutrition.characteristics_food_eaten && inhomesss.nutrition.characteristics_food_eaten.title !== '' && inhomesss.nutrition.characteristics_food_eaten.title !== null && inhomesss.nutrition.characteristics_food_eaten.title !== undefined ? inhomesss.nutrition.characteristics_food_eaten.title : '',
          detail: 'nutrition' in inhomesss && 'characteristics_food_eaten' in inhomesss.nutrition && 'detail' in inhomesss.nutrition.characteristics_food_eaten && inhomesss.nutrition.characteristics_food_eaten.detail !== '' && inhomesss.nutrition.characteristics_food_eaten.detail !== null && inhomesss.nutrition.characteristics_food_eaten.detail !== undefined ? inhomesss.nutrition.characteristics_food_eaten.detail : '',
        },
        taste_favorite_food: {
          sweet: {
            status: 'nutrition' in inhomesss && 'taste_favorite_food' in inhomesss.nutrition && 'sweet' in inhomesss.nutrition.taste_favorite_food && 'status' in inhomesss.nutrition.taste_favorite_food.sweet && inhomesss.nutrition.taste_favorite_food.sweet.status !== '' && inhomesss.nutrition.taste_favorite_food.sweet.status !== null && inhomesss.nutrition.taste_favorite_food.sweet.status !== undefined ? inhomesss.nutrition.taste_favorite_food.sweet.status : '',
            title: 'nutrition' in inhomesss && 'taste_favorite_food' in inhomesss.nutrition && 'sweet' in inhomesss.nutrition.taste_favorite_food && 'title' in inhomesss.nutrition.taste_favorite_food.sweet && inhomesss.nutrition.taste_favorite_food.sweet.title !== '' && inhomesss.nutrition.taste_favorite_food.sweet.title !== null && inhomesss.nutrition.taste_favorite_food.sweet.title !== undefined ? inhomesss.nutrition.taste_favorite_food.sweet.title : '',
          },
          oily: {
            status: 'nutrition' in inhomesss && 'taste_favorite_food' in inhomesss.nutrition && 'oily' in inhomesss.nutrition.taste_favorite_food && 'status' in inhomesss.nutrition.taste_favorite_food.oily && inhomesss.nutrition.taste_favorite_food.oily.status !== '' && inhomesss.nutrition.taste_favorite_food.oily.status !== null && inhomesss.nutrition.taste_favorite_food.oily.status !== undefined ? inhomesss.nutrition.taste_favorite_food.oily.status : '',
            title: 'nutrition' in inhomesss && 'taste_favorite_food' in inhomesss.nutrition && 'oily' in inhomesss.nutrition.taste_favorite_food && 'title' in inhomesss.nutrition.taste_favorite_food.oily && inhomesss.nutrition.taste_favorite_food.oily.title !== '' && inhomesss.nutrition.taste_favorite_food.oily.title !== null && inhomesss.nutrition.taste_favorite_food.oily.title !== undefined ? inhomesss.nutrition.taste_favorite_food.oily.title : '',
          },
          salty: {
            status: 'nutrition' in inhomesss && 'taste_favorite_food' in inhomesss.nutrition && 'salty' in inhomesss.nutrition.taste_favorite_food && 'status' in inhomesss.nutrition.taste_favorite_food.salty && inhomesss.nutrition.taste_favorite_food.salty.status !== '' && inhomesss.nutrition.taste_favorite_food.salty.status !== null && inhomesss.nutrition.taste_favorite_food.salty.status !== undefined ? inhomesss.nutrition.taste_favorite_food.salty.status : '',
            title: 'nutrition' in inhomesss && 'taste_favorite_food' in inhomesss.nutrition && 'salty' in inhomesss.nutrition.taste_favorite_food && 'title' in inhomesss.nutrition.taste_favorite_food.salty && inhomesss.nutrition.taste_favorite_food.salty.title !== '' && inhomesss.nutrition.taste_favorite_food.salty.title !== null && inhomesss.nutrition.taste_favorite_food.salty.title !== undefined ? inhomesss.nutrition.taste_favorite_food.salty.title : '',
          },
          spicy: {
            status: 'nutrition' in inhomesss && 'taste_favorite_food' in inhomesss.nutrition && 'spicy' in inhomesss.nutrition.taste_favorite_food && 'status' in inhomesss.nutrition.taste_favorite_food.spicy && inhomesss.nutrition.taste_favorite_food.spicy.status !== '' && inhomesss.nutrition.taste_favorite_food.spicy.status !== null && inhomesss.nutrition.taste_favorite_food.spicy.status !== undefined ? inhomesss.nutrition.taste_favorite_food.spicy.status : '',
            title: 'nutrition' in inhomesss && 'taste_favorite_food' in inhomesss.nutrition && 'spicy' in inhomesss.nutrition.taste_favorite_food && 'title' in inhomesss.nutrition.taste_favorite_food.spicy && inhomesss.nutrition.taste_favorite_food.spicy.title !== '' && inhomesss.nutrition.taste_favorite_food.spicy.title !== null && inhomesss.nutrition.taste_favorite_food.spicy.title !== undefined ? inhomesss.nutrition.taste_favorite_food.spicy.title : '',
          },
          sour: {
            status: 'nutrition' in inhomesss && 'taste_favorite_food' in inhomesss.nutrition && 'sour' in inhomesss.nutrition.taste_favorite_food && 'status' in inhomesss.nutrition.taste_favorite_food.sour && inhomesss.nutrition.taste_favorite_food.sour.status !== '' && inhomesss.nutrition.taste_favorite_food.sour.status !== null && inhomesss.nutrition.taste_favorite_food.sour.status !== undefined ? inhomesss.nutrition.taste_favorite_food.sour.status : '',
            title: 'nutrition' in inhomesss && 'taste_favorite_food' in inhomesss.nutrition && 'sour' in inhomesss.nutrition.taste_favorite_food && 'title' in inhomesss.nutrition.taste_favorite_food.sour && inhomesss.nutrition.taste_favorite_food.sour .title !== '' && inhomesss.nutrition.taste_favorite_food.sour .title !== null && inhomesss.nutrition.taste_favorite_food.sour .title !== undefined ? inhomesss.nutrition.taste_favorite_food.sour .title : '',
          },
          other: {
            status: 'nutrition' in inhomesss && 'taste_favorite_food' in inhomesss.nutrition && 'other' in inhomesss.nutrition.taste_favorite_food && 'status' in inhomesss.nutrition.taste_favorite_food.other && inhomesss.nutrition.taste_favorite_food.other.status !== '' && inhomesss.nutrition.taste_favorite_food.other.status !== null && inhomesss.nutrition.taste_favorite_food.other.status !== undefined ? inhomesss.nutrition.taste_favorite_food.other.status : '',
            title: 'nutrition' in inhomesss && 'taste_favorite_food' in inhomesss.nutrition && 'other' in inhomesss.nutrition.taste_favorite_food && 'title' in inhomesss.nutrition.taste_favorite_food.other && inhomesss.nutrition.taste_favorite_food.other.title !== '' && inhomesss.nutrition.taste_favorite_food.other.title !== null && inhomesss.nutrition.taste_favorite_food.other.title !== undefined ? inhomesss.nutrition.taste_favorite_food.other.title : '',
            detail: 'nutrition' in inhomesss && 'taste_favorite_food' in inhomesss.nutrition && 'other' in inhomesss.nutrition.taste_favorite_food && 'detail' in inhomesss.nutrition.taste_favorite_food.other && inhomesss.nutrition.taste_favorite_food.other.detail !== '' && inhomesss.nutrition.taste_favorite_food.other.detail !== null && inhomesss.nutrition.taste_favorite_food.other.detail !== undefined ? inhomesss.nutrition.taste_favorite_food.other.detail : '',
          },
        },
        food_appropriate_disease: {
          status: 'nutrition' in inhomesss && 'food_appropriate_disease' in inhomesss.nutrition && 'status' in inhomesss.nutrition.food_appropriate_disease && inhomesss.nutrition.food_appropriate_disease.status !== '' && inhomesss.nutrition.food_appropriate_disease.status !== null && inhomesss.nutrition.food_appropriate_disease.status !== undefined ? inhomesss.nutrition.food_appropriate_disease.status : '',
          title: 'nutrition' in inhomesss && 'food_appropriate_disease' in inhomesss.nutrition && 'title' in inhomesss.nutrition.food_appropriate_disease && inhomesss.nutrition.food_appropriate_disease.title !== '' && inhomesss.nutrition.food_appropriate_disease.title !== null && inhomesss.nutrition.food_appropriate_disease.title !== undefined ? inhomesss.nutrition.food_appropriate_disease.title : '',
          detail: 'nutrition' in inhomesss && 'food_appropriate_disease' in inhomesss.nutrition && 'detail' in inhomesss.nutrition.food_appropriate_disease && inhomesss.nutrition.food_appropriate_disease.detail !== '' && inhomesss.nutrition.food_appropriate_disease.detail !== null && inhomesss.nutrition.food_appropriate_disease.detail !== undefined ? inhomesss.nutrition.food_appropriate_disease.detail : '',
        },
        number_food_day:'nutrition' in inhomesss && 'number_food_day' in inhomesss.nutrition && inhomesss.nutrition.number_food_day !== '' && inhomesss.nutrition.number_food_day !== null && inhomesss.nutrition.number_food_day !== undefined ? inhomesss.nutrition.number_food_day : 0,
        food_handler: 'nutrition' in inhomesss && 'food_handler' in inhomesss.nutrition && inhomesss.nutrition.food_handler !== '' && inhomesss.nutrition.food_handler !== null && inhomesss.nutrition.food_handler !== undefined ? inhomesss.nutrition.food_handler : '',
        food_origin: {
          homemade: {
            status: 'nutrition' in inhomesss && 'food_origin' in inhomesss.nutrition && 'homemade' in inhomesss.nutrition.food_origin && 'status' in inhomesss.nutrition.food_origin.homemade && inhomesss.nutrition.food_origin.homemade.status !== '' && inhomesss.nutrition.food_origin.homemade.status !== null && inhomesss.nutrition.food_origin.homemade.status !== undefined ? inhomesss.nutrition.food_origin.homemade.status : '',
            title: 'nutrition' in inhomesss && 'food_origin' in inhomesss.nutrition && 'homemade' in inhomesss.nutrition.food_origin && 'title' in inhomesss.nutrition.food_origin.homemade && inhomesss.nutrition.food_origin.homemade.title !== '' && inhomesss.nutrition.food_origin.homemade.title !== null && inhomesss.nutrition.food_origin.homemade.title !== undefined ? inhomesss.nutrition.food_origin.homemade.title : '',
          },
          deli: {
            status: 'nutrition' in inhomesss && 'food_origin' in inhomesss.nutrition && 'deli' in inhomesss.nutrition.food_origin && 'status' in inhomesss.nutrition.food_origin.deli && inhomesss.nutrition.food_origin.deli.status !== '' && inhomesss.nutrition.food_origin.deli.status !== null && inhomesss.nutrition.food_origin.deli.status !== undefined ? inhomesss.nutrition.food_origin.deli.status : '',
            title: 'nutrition' in inhomesss && 'food_origin' in inhomesss.nutrition && 'deli' in inhomesss.nutrition.food_origin && 'title' in inhomesss.nutrition.food_origin.deli && inhomesss.nutrition.food_origin.deli.title !== '' && inhomesss.nutrition.food_origin.deli.title !== null && inhomesss.nutrition.food_origin.deli.title !== undefined ? inhomesss.nutrition.food_origin.deli.title : '',
          },
          frozen_food: {
            status: 'nutrition' in inhomesss && 'food_origin' in inhomesss.nutrition && 'frozen_food' in inhomesss.nutrition.food_origin && 'status' in inhomesss.nutrition.food_origin.frozen_food && inhomesss.nutrition.food_origin.frozen_food.status !== '' && inhomesss.nutrition.food_origin.frozen_food.status !== null && inhomesss.nutrition.food_origin.frozen_food.status !== undefined ? inhomesss.nutrition.food_origin.frozen_food.status : '',
            title: 'nutrition' in inhomesss && 'food_origin' in inhomesss.nutrition && 'frozen_food' in inhomesss.nutrition.food_origin && 'title' in inhomesss.nutrition.food_origin.frozen_food && inhomesss.nutrition.food_origin.frozen_food.title !== '' && inhomesss.nutrition.food_origin.frozen_food.title !== null && inhomesss.nutrition.food_origin.frozen_food.title !== undefined ? inhomesss.nutrition.food_origin.frozen_food.title : '',
          },
          other: {
            status: 'nutrition' in inhomesss && 'food_origin' in inhomesss.nutrition && 'other' in inhomesss.nutrition.food_origin && 'status' in inhomesss.nutrition.food_origin.other && inhomesss.nutrition.food_origin.other.status !== '' && inhomesss.nutrition.food_origin.other.status !== null && inhomesss.nutrition.food_origin.other.status !== undefined ? inhomesss.nutrition.food_origin.other.status : '',
            title: 'nutrition' in inhomesss && 'food_origin' in inhomesss.nutrition && 'other' in inhomesss.nutrition.food_origin && 'title' in inhomesss.nutrition.food_origin.other && inhomesss.nutrition.food_origin.other.title !== '' && inhomesss.nutrition.food_origin.other.title !== null && inhomesss.nutrition.food_origin.other.title !== undefined ? inhomesss.nutrition.food_origin.other.title : '',
            detail: 'nutrition' in inhomesss && 'food_origin' in inhomesss.nutrition && 'other' in inhomesss.nutrition.food_origin && 'detail' in inhomesss.nutrition.food_origin.other && inhomesss.nutrition.food_origin.other.detail !== '' && inhomesss.nutrition.food_origin.other.detail !== null && inhomesss.nutrition.food_origin.other.detail !== undefined ? inhomesss.nutrition.food_origin.other.detail : '',
          },
        },
        eating: {
          status: 'nutrition' in inhomesss && 'eating' in inhomesss.nutrition && 'status' in inhomesss.nutrition.eating && inhomesss.nutrition.eating.status !== '' && inhomesss.nutrition.eating.status !== null && inhomesss.nutrition.eating.status !== undefined ? inhomesss.nutrition.eating.status : '',
          title: 'nutrition' in inhomesss && 'eating' in inhomesss.nutrition && 'title' in inhomesss.nutrition.eating && inhomesss.nutrition.eating.title !== '' && inhomesss.nutrition.eating.title !== null && inhomesss.nutrition.eating.title !== undefined ? inhomesss.nutrition.eating.title : '',
        },
        alcohol_drink: {
          status: 'nutrition' in inhomesss && 'alcohol_drink' in inhomesss.nutrition && 'status' in inhomesss.nutrition.alcohol_drink && inhomesss.nutrition.alcohol_drink.status !== '' && inhomesss.nutrition.alcohol_drink.status !== null && inhomesss.nutrition.alcohol_drink.status !== undefined ? inhomesss.nutrition.alcohol_drink.status : '',
          title: 'nutrition' in inhomesss && 'alcohol_drink' in inhomesss.nutrition && 'title' in inhomesss.nutrition.alcohol_drink && inhomesss.nutrition.alcohol_drink.title !== '' && inhomesss.nutrition.alcohol_drink.title !== null && inhomesss.nutrition.alcohol_drink.title !== undefined ? inhomesss.nutrition.alcohol_drink.title : '',
          volume_per_day: 'nutrition' in inhomesss && 'alcohol_drink' in inhomesss.nutrition && 'volume_per_day' in inhomesss.nutrition.alcohol_drink && inhomesss.nutrition.alcohol_drink.volume_per_day !== '' && inhomesss.nutrition.alcohol_drink.volume_per_day !== null && inhomesss.nutrition.alcohol_drink.volume_per_day !== undefined ? inhomesss.nutrition.alcohol_drink.volume_per_day : '',
        },
        cigarettes: {
          status: 'nutrition' in inhomesss && 'cigarettes' in inhomesss.nutrition && 'status' in inhomesss.nutrition.cigarettes && inhomesss.nutrition.cigarettes.status !== '' && inhomesss.nutrition.cigarettes.status !== null && inhomesss.nutrition.cigarettes.status !== undefined ? inhomesss.nutrition.cigarettes.status : '',
          title: 'nutrition' in inhomesss && 'cigarettes' in inhomesss.nutrition && 'title' in inhomesss.nutrition.cigarettes && inhomesss.nutrition.cigarettes.title !== '' && inhomesss.nutrition.cigarettes.title !== null && inhomesss.nutrition.cigarettes.title !== undefined ? inhomesss.nutrition.cigarettes.title : '',
          volume_per_day: 'nutrition' in inhomesss && 'cigarettes' in inhomesss.nutrition && 'volume_per_day' in inhomesss.nutrition.cigarettes && inhomesss.nutrition.cigarettes.volume_per_day !== '' && inhomesss.nutrition.cigarettes.volume_per_day !== null && inhomesss.nutrition.cigarettes.volume_per_day !== undefined ? inhomesss.nutrition.cigarettes.volume_per_day : '',
        },
        regular_drink: {
          coffee: {
            status: 'nutrition' in inhomesss && 'regular_drink' in inhomesss.nutrition && 'coffee' in inhomesss.nutrition.regular_drink && 'status' in inhomesss.nutrition.regular_drink.coffee && inhomesss.nutrition.regular_drink.coffee.status !== '' && inhomesss.nutrition.regular_drink.coffee.status !== null && inhomesss.nutrition.regular_drink.coffee.status !== undefined ? inhomesss.nutrition.regular_drink.coffee.status : '',
            title: 'nutrition' in inhomesss && 'regular_drink' in inhomesss.nutrition && 'coffee' in inhomesss.nutrition.regular_drink && 'title' in inhomesss.nutrition.regular_drink.coffee && inhomesss.nutrition.regular_drink.coffee.title !== '' && inhomesss.nutrition.regular_drink.coffee.title !== null && inhomesss.nutrition.regular_drink.coffee.title !== undefined ? inhomesss.nutrition.regular_drink.coffee.title : '',
          },
          tea: {
            status: 'nutrition' in inhomesss && 'regular_drink' in inhomesss.nutrition && 'tea' in inhomesss.nutrition.regular_drink && 'status' in inhomesss.nutrition.regular_drink.tea && inhomesss.nutrition.regular_drink.tea.status !== '' && inhomesss.nutrition.regular_drink.tea.status !== null && inhomesss.nutrition.regular_drink.tea.status !== undefined ? inhomesss.nutrition.regular_drink.tea.status : '',
            title: 'nutrition' in inhomesss && 'regular_drink' in inhomesss.nutrition && 'tea' in inhomesss.nutrition.regular_drink && 'title' in inhomesss.nutrition.regular_drink.tea && inhomesss.nutrition.regular_drink.tea.title !== '' && inhomesss.nutrition.regular_drink.tea.title !== null && inhomesss.nutrition.regular_drink.tea.title !== undefined ? inhomesss.nutrition.regular_drink.tea.title : '',
          },
          soft_drink: {
            status: 'nutrition' in inhomesss && 'regular_drink' in inhomesss.nutrition && 'soft_drink' in inhomesss.nutrition.regular_drink && 'status' in inhomesss.nutrition.regular_drink.soft_drink && inhomesss.nutrition.regular_drink.soft_drink.status !== '' && inhomesss.nutrition.regular_drink.soft_drink.status !== null && inhomesss.nutrition.regular_drink.soft_drink.status !== undefined ? inhomesss.nutrition.regular_drink.soft_drink.status : '',
            title: 'nutrition' in inhomesss && 'regular_drink' in inhomesss.nutrition && 'soft_drink' in inhomesss.nutrition.regular_drink && 'title' in inhomesss.nutrition.regular_drink.soft_drink && inhomesss.nutrition.regular_drink.soft_drink.title !== '' && inhomesss.nutrition.regular_drink.soft_drink.title !== null && inhomesss.nutrition.regular_drink.soft_drink.title !== undefined ? inhomesss.nutrition.regular_drink.soft_drink.title : '',
          },
          energy_drink: {
            status: 'nutrition' in inhomesss && 'regular_drink' in inhomesss.nutrition && 'energy_drink' in inhomesss.nutrition.regular_drink && 'status' in inhomesss.nutrition.regular_drink.energy_drink && inhomesss.nutrition.regular_drink.energy_drink.status !== '' && inhomesss.nutrition.regular_drink.energy_drink.status !== null && inhomesss.nutrition.regular_drink.energy_drink.status !== undefined ? inhomesss.nutrition.regular_drink.energy_drink.status : '',
            title: 'nutrition' in inhomesss && 'regular_drink' in inhomesss.nutrition && 'energy_drink' in inhomesss.nutrition.regular_drink && 'title' in inhomesss.nutrition.regular_drink.energy_drink && inhomesss.nutrition.regular_drink.energy_drink.title !== '' && inhomesss.nutrition.regular_drink.energy_drink.title !== null && inhomesss.nutrition.regular_drink.energy_drink.title !== undefined ? inhomesss.nutrition.regular_drink.energy_drink.title : '',
          },
          other: {
            status: 'nutrition' in inhomesss && 'regular_drink' in inhomesss.nutrition && 'other' in inhomesss.nutrition.regular_drink && 'status' in inhomesss.nutrition.regular_drink.other && inhomesss.nutrition.regular_drink.other.status !== '' && inhomesss.nutrition.regular_drink.other.status !== null && inhomesss.nutrition.regular_drink.other.status !== undefined ? inhomesss.nutrition.regular_drink.other.status : '',
            title: 'nutrition' in inhomesss && 'regular_drink' in inhomesss.nutrition && 'other' in inhomesss.nutrition.regular_drink && 'title' in inhomesss.nutrition.regular_drink.other && inhomesss.nutrition.regular_drink.other.title !== '' && inhomesss.nutrition.regular_drink.other.title !== null && inhomesss.nutrition.regular_drink.other.title !== undefined ? inhomesss.nutrition.regular_drink.other.title : '',
            detail: 'nutrition' in inhomesss && 'regular_drink' in inhomesss.nutrition && 'other' in inhomesss.nutrition.regular_drink && 'detail' in inhomesss.nutrition.regular_drink.other && inhomesss.nutrition.regular_drink.other.detail !== '' && inhomesss.nutrition.regular_drink.other.detail !== null && inhomesss.nutrition.regular_drink.other.detail !== undefined ? inhomesss.nutrition.regular_drink.other.detail : '',
          },
        },
        other_detail: 'nutrition' in inhomesss && 'other_detail' in inhomesss.nutrition && inhomesss.nutrition.other_detail !== '' && inhomesss.nutrition.other_detail !== null && inhomesss.nutrition.other_detail !== undefined ? inhomesss.nutrition.other_detail : '',
      }

      this.home_environment = {
        clean_house: {
          status: 'home_environment' in inhomesss && 'clean_house' in inhomesss.home_environment && 'status' in inhomesss.home_environment.clean_house && inhomesss.home_environment.clean_house.status !== '' && inhomesss.home_environment.clean_house.status !== null && inhomesss.home_environment.clean_house.status !== undefined ? inhomesss.home_environment.clean_house.status : '',
          title: 'home_environment' in inhomesss && 'clean_house' in inhomesss.home_environment && 'title' in inhomesss.home_environment.clean_house && inhomesss.home_environment.clean_house.title !== '' && inhomesss.home_environment.clean_house.title !== null && inhomesss.home_environment.clean_house.title !== undefined ? inhomesss.home_environment.clean_house.title : '',
        }, //true = 1, false = 0
        orderliness_house: {
          status: 'home_environment' in inhomesss && 'orderliness_house' in inhomesss.home_environment && 'status' in inhomesss.home_environment.orderliness_house && inhomesss.home_environment.orderliness_house.status !== '' && inhomesss.home_environment.orderliness_house.status !== null && inhomesss.home_environment.orderliness_house.status !== undefined ? inhomesss.home_environment.orderliness_house.status : '',
          title: 'home_environment' in inhomesss && 'orderliness_house' in inhomesss.home_environment && 'title' in inhomesss.home_environment.orderliness_house && inhomesss.home_environment.orderliness_house.title !== '' && inhomesss.home_environment.orderliness_house.title !== null && inhomesss.home_environment.orderliness_house.title !== undefined ? inhomesss.home_environment.orderliness_house.title : '',
        },
        light_of_house: {
          status: 'home_environment' in inhomesss && 'light_of_house' in inhomesss.home_environment && 'status' in inhomesss.home_environment.light_of_house && inhomesss.home_environment.light_of_house.status !== '' && inhomesss.home_environment.light_of_house.status !== null && inhomesss.home_environment.light_of_house.status !== undefined ? inhomesss.home_environment.light_of_house.status : '',
          title: 'home_environment' in inhomesss && 'light_of_house' in inhomesss.home_environment && 'title' in inhomesss.home_environment.light_of_house && inhomesss.home_environment.light_of_house.title !== '' && inhomesss.home_environment.light_of_house.title !== null && inhomesss.home_environment.light_of_house.title !== undefined ? inhomesss.home_environment.light_of_house.title : '',
        },
        indoor_air: {
          status: 'home_environment' in inhomesss && 'indoor_air' in inhomesss.home_environment && 'status' in inhomesss.home_environment.indoor_air && inhomesss.home_environment.indoor_air.status !== '' && inhomesss.home_environment.indoor_air.status !== null && inhomesss.home_environment.indoor_air.status !== undefined ? inhomesss.home_environment.indoor_air.status : '',
          title: 'home_environment' in inhomesss && 'indoor_air' in inhomesss.home_environment && 'title' in inhomesss.home_environment.indoor_air && inhomesss.home_environment.indoor_air.title !== '' && inhomesss.home_environment.indoor_air.title !== null && inhomesss.home_environment.indoor_air.title !== undefined ? inhomesss.home_environment.indoor_air.title : '',
        },
        security: {
          status: 'home_environment' in inhomesss && 'security' in inhomesss.home_environment && 'status' in inhomesss.home_environment.security && inhomesss.home_environment.security.status !== '' && inhomesss.home_environment.security.status !== null && inhomesss.home_environment.security.status !== undefined ? inhomesss.home_environment.security.status : '',
          title: 'home_environment' in inhomesss && 'security' in inhomesss.home_environment && 'title' in inhomesss.home_environment.security && inhomesss.home_environment.security.title !== '' && inhomesss.home_environment.security.title !== null && inhomesss.home_environment.security.title !== undefined ? inhomesss.home_environment.security.title : '',
          detail: 'home_environment' in inhomesss && 'security' in inhomesss.home_environment && 'detail' in inhomesss.home_environment.security && inhomesss.home_environment.security.detail !== '' && inhomesss.home_environment.security.detail !== null && inhomesss.home_environment.security.detail !== undefined ? inhomesss.home_environment.security.detail : '',
        },
        area_around_house: {
          waterlogged: {
            status: 'home_environment' in inhomesss && 'area_around_house' in inhomesss.home_environment && 'waterlogged' in inhomesss.home_environment.area_around_house && 'status' in inhomesss.home_environment.area_around_house.waterlogged && inhomesss.home_environment.area_around_house.waterlogged.status !== '' && inhomesss.home_environment.area_around_house.waterlogged.status !== null && inhomesss.home_environment.area_around_house.waterlogged.status !== undefined ? inhomesss.home_environment.area_around_house.waterlogged.status : '',
            title: 'home_environment' in inhomesss && 'area_around_house' in inhomesss.home_environment && 'waterlogged' in inhomesss.home_environment.area_around_house && 'title' in inhomesss.home_environment.area_around_house.waterlogged && inhomesss.home_environment.area_around_house.waterlogged.title !== '' && inhomesss.home_environment.area_around_house.waterlogged.title !== null && inhomesss.home_environment.area_around_house.waterlogged.title !== undefined ? inhomesss.home_environment.area_around_house.waterlogged.title : '',
          },
          overgrown: {
            status: 'home_environment' in inhomesss && 'area_around_house' in inhomesss.home_environment && 'overgrown' in inhomesss.home_environment.area_around_house && 'status' in inhomesss.home_environment.area_around_house.overgrown && inhomesss.home_environment.area_around_house.overgrown.status !== '' && inhomesss.home_environment.area_around_house.overgrown.status !== null && inhomesss.home_environment.area_around_house.overgrown.status !== undefined ? inhomesss.home_environment.area_around_house.overgrown.status : '',
            title: 'home_environment' in inhomesss && 'area_around_house' in inhomesss.home_environment && 'overgrown' in inhomesss.home_environment.area_around_house && 'title' in inhomesss.home_environment.area_around_house.overgrown && inhomesss.home_environment.area_around_house.overgrown.title !== '' && inhomesss.home_environment.area_around_house.overgrown.title !== null && inhomesss.home_environment.area_around_house.overgrown.title !== undefined ? inhomesss.home_environment.area_around_house.overgrown.title : '',
          },
          other: {
            status: 'home_environment' in inhomesss && 'area_around_house' in inhomesss.home_environment && 'other' in inhomesss.home_environment.area_around_house && 'status' in inhomesss.home_environment.area_around_house.other && inhomesss.home_environment.area_around_house.other.status !== '' && inhomesss.home_environment.area_around_house.other.status !== null && inhomesss.home_environment.area_around_house.other.status !== undefined ? inhomesss.home_environment.area_around_house.other.status : '',
            title: 'home_environment' in inhomesss && 'area_around_house' in inhomesss.home_environment && 'other' in inhomesss.home_environment.area_around_house && 'title' in inhomesss.home_environment.area_around_house.other && inhomesss.home_environment.area_around_house.other.title !== '' && inhomesss.home_environment.area_around_house.other.title !== null && inhomesss.home_environment.area_around_house.other.title !== undefined ? inhomesss.home_environment.area_around_house.other.title : '',
            detail: 'home_environment' in inhomesss && 'area_around_house' in inhomesss.home_environment && 'other' in inhomesss.home_environment.area_around_house && 'detail' in inhomesss.home_environment.area_around_house.other && inhomesss.home_environment.area_around_house.other.detail !== '' && inhomesss.home_environment.area_around_house.other.detail !== null && inhomesss.home_environment.area_around_house.other.detail !== undefined ? inhomesss.home_environment.area_around_house.other.detail : '',
          }
        },
      }

      this.other_people = {
        relation_family_member: {
          status: 'other_people' in inhomesss && 'relation_family_member' in inhomesss.other_people && 'status' in inhomesss.other_people.relation_family_member && inhomesss.other_people.relation_family_member.status !== '' && inhomesss.other_people.relation_family_member.status !== null && inhomesss.other_people.relation_family_member.status !== undefined ? inhomesss.other_people.relation_family_member.status : '',
          title: 'other_people' in inhomesss && 'relation_family_member' in inhomesss.other_people && 'title' in inhomesss.other_people.relation_family_member && inhomesss.other_people.relation_family_member.title !== '' && inhomesss.other_people.relation_family_member.title !== null && inhomesss.other_people.relation_family_member.title !== undefined ? inhomesss.other_people.relation_family_member.title : '',
        },
        family_help: {
          status: 'other_people' in inhomesss && 'family_help' in inhomesss.other_people && 'status' in inhomesss.other_people.family_help && inhomesss.other_people.family_help.status !== '' && inhomesss.other_people.family_help.status !== null && inhomesss.other_people.family_help.status !== undefined ? inhomesss.other_people.family_help.status : '',
          title: 'other_people' in inhomesss && 'family_help' in inhomesss.other_people && 'title' in inhomesss.other_people.family_help && inhomesss.other_people.family_help.title !== '' && inhomesss.other_people.family_help.title !== null && inhomesss.other_people.family_help.title !== undefined ? inhomesss.other_people.family_help.title : '',
        },
        patient_emergencythe_dispatcher: {
          status: 'other_people' in inhomesss && 'patient_emergencythe_dispatcher' in inhomesss.other_people && 'status' in inhomesss.other_people.patient_emergencythe_dispatcher && inhomesss.other_people.patient_emergencythe_dispatcher.status !== '' && inhomesss.other_people.patient_emergencythe_dispatcher.status !== null && inhomesss.other_people.patient_emergencythe_dispatcher.status !== undefined ? inhomesss.other_people.patient_emergencythe_dispatcher.status : '',
          title: 'other_people' in inhomesss && 'patient_emergencythe_dispatcher' in inhomesss.other_people && 'title' in inhomesss.other_people.patient_emergencythe_dispatcher && inhomesss.other_people.patient_emergencythe_dispatcher.title !== '' && inhomesss.other_people.patient_emergencythe_dispatcher.title !== null && inhomesss.other_people.patient_emergencythe_dispatcher.title !== undefined ? inhomesss.other_people.patient_emergencythe_dispatcher.title : '',
          detail: 'other_people' in inhomesss && 'patient_emergencythe_dispatcher' in inhomesss.other_people && 'detail' in inhomesss.other_people.patient_emergencythe_dispatcher && inhomesss.other_people.patient_emergencythe_dispatcher.detail !== '' && inhomesss.other_people.patient_emergencythe_dispatcher.detail !== null && inhomesss.other_people.patient_emergencythe_dispatcher.detail !== undefined ? inhomesss.other_people.patient_emergencythe_dispatcher.detail : '',
        },
        caregiver_risk_health: {
          status: 'other_people' in inhomesss && 'caregiver_risk_health' in inhomesss.other_people && 'status' in inhomesss.other_people.caregiver_risk_health && inhomesss.other_people.caregiver_risk_health.status !== '' && inhomesss.other_people.caregiver_risk_health.status !== null && inhomesss.other_people.caregiver_risk_health.status !== undefined ? inhomesss.other_people.caregiver_risk_health.status : '',
          title: 'other_people' in inhomesss && 'caregiver_risk_health' in inhomesss.other_people && 'title' in inhomesss.other_people.caregiver_risk_health && inhomesss.other_people.caregiver_risk_health.title !== '' && inhomesss.other_people.caregiver_risk_health.title !== null && inhomesss.other_people.caregiver_risk_health.title !== undefined ? inhomesss.other_people.caregiver_risk_health.title : '',
        },
        treatment_decision_maker: {
          status: 'other_people' in inhomesss && 'treatment_decision_maker' in inhomesss.other_people && 'status' in inhomesss.other_people.treatment_decision_maker && inhomesss.other_people.treatment_decision_maker.status !== '' && inhomesss.other_people.treatment_decision_maker.status !== null && inhomesss.other_people.treatment_decision_maker.status !== undefined ? inhomesss.other_people.treatment_decision_maker.status : '',
          title: 'other_people' in inhomesss && 'treatment_decision_maker' in inhomesss.other_people && 'title' in inhomesss.other_people.treatment_decision_maker && inhomesss.other_people.treatment_decision_maker.title !== '' && inhomesss.other_people.treatment_decision_maker.title !== null && inhomesss.other_people.treatment_decision_maker.title !== undefined ? inhomesss.other_people.treatment_decision_maker.title : '',
          name: 'other_people' in inhomesss && 'treatment_decision_maker' in inhomesss.other_people && 'name' in inhomesss.other_people.treatment_decision_maker && inhomesss.other_people.treatment_decision_maker.name !== '' && inhomesss.other_people.treatment_decision_maker.name !== null && inhomesss.other_people.treatment_decision_maker.name !== undefined ? inhomesss.other_people.treatment_decision_maker.name : '',
          mobile: 'other_people' in inhomesss && 'treatment_decision_maker' in inhomesss.other_people && 'mobile' in inhomesss.other_people.treatment_decision_maker && inhomesss.other_people.treatment_decision_maker.mobile !== '' && inhomesss.other_people.treatment_decision_maker.mobile !== null && inhomesss.other_people.treatment_decision_maker.mobile !== undefined ? inhomesss.other_people.treatment_decision_maker.mobile : '',
        }
      }

      this.medication = {
        administration_medicine: {
          status: 'medication' in inhomesss && 'administration_medicine' in inhomesss.medication && 'status' in inhomesss.medication.administration_medicine && inhomesss.medication.administration_medicine.status !== '' && inhomesss.medication.administration_medicine.status !== null && inhomesss.medication.administration_medicine.status !== undefined ? inhomesss.medication.administration_medicine.status : '',
          title: 'medication' in inhomesss && 'administration_medicine' in inhomesss.medication && 'title' in inhomesss.medication.administration_medicine && inhomesss.medication.administration_medicine.title !== '' && inhomesss.medication.administration_medicine.title !== null && inhomesss.medication.administration_medicine.title !== undefined ? inhomesss.medication.administration_medicine.title : '',
        },
        get_medicine: {
          status: 'medication' in inhomesss && 'get_medicine' in inhomesss.medication && 'status' in inhomesss.medication.get_medicine && inhomesss.medication.get_medicine.status !== '' && inhomesss.medication.get_medicine.status !== null && inhomesss.medication.get_medicine.status !== undefined ? inhomesss.medication.get_medicine.status : '',
          title: 'medication' in inhomesss && 'get_medicine' in inhomesss.medication && 'title' in inhomesss.medication.get_medicine && inhomesss.medication.get_medicine.title !== '' && inhomesss.medication.get_medicine.title !== null && inhomesss.medication.get_medicine.title !== undefined ? inhomesss.medication.get_medicine.title : '',
        },
        regular_medicine: 'medication' in inhomesss && 'regular_medicine' in inhomesss.medication && inhomesss.medication.regular_medicine !== '' && inhomesss.medication.regular_medicine !== null && inhomesss.medication.regular_medicine !== undefined ? inhomesss.medication.regular_medicine : '',
        supplementary_food: 'medication' in inhomesss && 'supplementary_food' in inhomesss.medication && inhomesss.medication.supplementary_food !== '' && inhomesss.medication.supplementary_food !== null && inhomesss.medication.supplementary_food !== undefined ? inhomesss.medication.supplementary_food : '',
        herbal_medicine: 'medication' in inhomesss && 'herbal_medicine' in inhomesss.medication && inhomesss.medication.herbal_medicine !== '' && inhomesss.medication.herbal_medicine !== null && inhomesss.medication.herbal_medicine !== undefined ? inhomesss.medication.herbal_medicine : '',
        other: 'medication' in inhomesss && 'other' in inhomesss.medication && inhomesss.medication.other !== '' && inhomesss.medication.other !== null && inhomesss.medication.other !== undefined ? inhomesss.medication.other : '',
      }

      this.examination = {
        V_S: {
          T: {
            value_1: 'examination' in inhomesss && 'V_S' in inhomesss.examination && 'T' in inhomesss.examination.V_S && 'value_1' in inhomesss.examination.V_S.T && inhomesss.examination.V_S.T.value_1 !== '' && inhomesss.examination.V_S.T.value_1 !== null && inhomesss.examination.V_S.T.value_1 !== undefined ? inhomesss.examination.V_S.T.value_1 : '',
          },
          BP: {
            value_1: 'examination' in inhomesss && 'V_S' in inhomesss.examination && 'BP' in inhomesss.examination.V_S && 'value_1' in inhomesss.examination.V_S.BP && inhomesss.examination.V_S.BP.value_1 !== '' && inhomesss.examination.V_S.BP.value_1 !== null && inhomesss.examination.V_S.BP.value_1 !== undefined ? inhomesss.examination.V_S.BP.value_1 : '',
            value_2: 'examination' in inhomesss && 'V_S' in inhomesss.examination && 'BP' in inhomesss.examination.V_S && 'value_2' in inhomesss.examination.V_S.BP && inhomesss.examination.V_S.BP.value_2 !== '' && inhomesss.examination.V_S.BP.value_2 !== null && inhomesss.examination.V_S.BP.value_2 !== undefined ? inhomesss.examination.V_S.BP.value_2 : '',
          },
          RR: {
            value_1: 'examination' in inhomesss && 'V_S' in inhomesss.examination && 'RR' in inhomesss.examination.V_S && 'value_1' in inhomesss.examination.V_S.RR && inhomesss.examination.V_S.RR.value_1 !== '' && inhomesss.examination.V_S.RR.value_1 !== null && inhomesss.examination.V_S.RR.value_1 !== undefined ? inhomesss.examination.V_S.RR.value_1 : '',
          },
          PR: {
            value_1: 'examination' in inhomesss && 'V_S' in inhomesss.examination && 'PR' in inhomesss.examination.V_S && 'value_1' in inhomesss.examination.V_S.PR && inhomesss.examination.V_S.PR.value_1 !== '' && inhomesss.examination.V_S.PR.value_1 !== null && inhomesss.examination.V_S.PR.value_1 !== undefined ? inhomesss.examination.V_S.PR.value_1 : '',
          },
          PE: {
            value_1: 'examination' in inhomesss && 'V_S' in inhomesss.examination && 'PE' in inhomesss.examination.V_S && 'value_1' in inhomesss.examination.V_S.PE && inhomesss.examination.V_S.PE.value_1 !== '' && inhomesss.examination.V_S.PE.value_1 !== null && inhomesss.examination.V_S.PE.value_1 !== undefined ? inhomesss.examination.V_S.PE.value_1 : '',
          }
        }
      }

      this.safety = {
        fell_down_safety: {
          status: 'safety' in inhomesss && 'fell_down_safety' in inhomesss.safety && 'status' in inhomesss.safety.fell_down_safety && inhomesss.safety.fell_down_safety.status !== '' && inhomesss.safety.fell_down_safety.status !== null && inhomesss.safety.fell_down_safety.status !== undefined ? inhomesss.safety.fell_down_safety.status : '',
          title: 'safety' in inhomesss && 'fell_down_safety' in inhomesss.safety && 'title' in inhomesss.safety.fell_down_safety && inhomesss.safety.fell_down_safety.title !== '' && inhomesss.safety.fell_down_safety.title !== null && inhomesss.safety.fell_down_safety.title !== undefined ? inhomesss.safety.fell_down_safety.title : '',
        },
        indoor_safety: {
          status: 'safety' in inhomesss && 'indoor_safety' in inhomesss.safety && 'status' in inhomesss.safety.indoor_safety && inhomesss.safety.indoor_safety.status !== '' && inhomesss.safety.indoor_safety.status !== null && inhomesss.safety.indoor_safety.status !== undefined ? inhomesss.safety.indoor_safety.status : '',
          title: 'safety' in inhomesss && 'indoor_safety' in inhomesss.safety && 'title' in inhomesss.safety.indoor_safety && inhomesss.safety.indoor_safety.title !== '' && inhomesss.safety.indoor_safety.title !== null && inhomesss.safety.indoor_safety.title !== undefined ? inhomesss.safety.indoor_safety.title : '',
          detail: 'safety' in inhomesss && 'indoor_safety' in inhomesss.safety && 'detail' in inhomesss.safety.indoor_safety && inhomesss.safety.indoor_safety.detail !== '' && inhomesss.safety.indoor_safety.detail !== null && inhomesss.safety.indoor_safety.detail !== undefined ? inhomesss.safety.indoor_safety.detail : '',
        }
      }

      this.spiritual_health = {
        spiritual: 'spiritual_health' in inhomesss && 'spiritual' in inhomesss.spiritual_health && inhomesss.spiritual_health.spiritual !== '' && inhomesss.spiritual_health.spiritual !== null && inhomesss.spiritual_health.spiritual !== undefined ? inhomesss.spiritual_health.spiritual : '',
        belief: {
          status: 'spiritual_health' in inhomesss && 'belief' in inhomesss.spiritual_health && 'status' in inhomesss.spiritual_health.belief && inhomesss.spiritual_health.belief.status !== '' && inhomesss.spiritual_health.belief.status !== null && inhomesss.spiritual_health.belief.status !== undefined ? inhomesss.spiritual_health.belief.status : '',
          title: 'spiritual_health' in inhomesss && 'belief' in inhomesss.spiritual_health && 'title' in inhomesss.spiritual_health.belief && inhomesss.spiritual_health.belief.title !== '' && inhomesss.spiritual_health.belief.title !== null && inhomesss.spiritual_health.belief.title !== undefined ? inhomesss.spiritual_health.belief.title : '',
          detail: 'spiritual_health' in inhomesss && 'belief' in inhomesss.spiritual_health && 'detail' in inhomesss.spiritual_health.belief && inhomesss.spiritual_health.belief.detail !== '' && inhomesss.spiritual_health.belief.detail !== null && inhomesss.spiritual_health.belief.detail !== undefined ? inhomesss.spiritual_health.belief.detail : '',
        }
      },

      this.local_service = {
        hospital: {
          status: 'local_service' in inhomesss && 'hospital' in inhomesss.local_service && 'status' in inhomesss.local_service.hospital && inhomesss.local_service.hospital.status !== '' && inhomesss.local_service.hospital.status !== null && inhomesss.local_service.hospital.status !== undefined ? inhomesss.local_service.hospital.status : '',
          title: 'local_service' in inhomesss && 'hospital' in inhomesss.local_service && 'title' in inhomesss.local_service.hospital && inhomesss.local_service.hospital.title !== '' && inhomesss.local_service.hospital.title !== null && inhomesss.local_service.hospital.title !== undefined ? inhomesss.local_service.hospital.title : '',
          detail: 'local_service' in inhomesss && 'hospital' in inhomesss.local_service && 'detail' in inhomesss.local_service.hospital && inhomesss.local_service.hospital.detail !== '' && inhomesss.local_service.hospital.detail !== null && inhomesss.local_service.hospital.detail !== undefined ? inhomesss.local_service.hospital.detail : '',
        },
        local_hospital: {
          status: 'local_service' in inhomesss && 'local_hospital' in inhomesss.local_service && 'status' in inhomesss.local_service.local_hospital && inhomesss.local_service.local_hospital.status !== '' && inhomesss.local_service.local_hospital.status !== null && inhomesss.local_service.local_hospital.status !== undefined ? inhomesss.local_service.local_hospital.status : '',
          title: 'local_service' in inhomesss && 'local_hospital' in inhomesss.local_service && 'title' in inhomesss.local_service.local_hospital && inhomesss.local_service.local_hospital.title !== '' && inhomesss.local_service.local_hospital.title !== null && inhomesss.local_service.local_hospital.title !== undefined ? inhomesss.local_service.local_hospital.title : '',
          detail: 'local_service' in inhomesss && 'local_hospital' in inhomesss.local_service && 'detail' in inhomesss.local_service.local_hospital && inhomesss.local_service.local_hospital.detail !== '' && inhomesss.local_service.local_hospital.detail !== null && inhomesss.local_service.local_hospital.detail !== undefined ? inhomesss.local_service.local_hospital.detail : '',
        },
        clinic: {
          status: 'local_service' in inhomesss && 'clinic' in inhomesss.local_service && 'status' in inhomesss.local_service.clinic && inhomesss.local_service.clinic.status !== '' && inhomesss.local_service.clinic.status !== null && inhomesss.local_service.clinic.status !== undefined ? inhomesss.local_service.clinic.status : '',
          title: 'local_service' in inhomesss && 'clinic' in inhomesss.local_service && 'title' in inhomesss.local_service.clinic && inhomesss.local_service.clinic.title !== '' && inhomesss.local_service.clinic.title !== null && inhomesss.local_service.clinic.title !== undefined ? inhomesss.local_service.clinic.title : '',
          detail: 'local_service' in inhomesss && 'clinic' in inhomesss.local_service && 'detail' in inhomesss.local_service.clinic && inhomesss.local_service.clinic.detail !== '' && inhomesss.local_service.clinic.detail !== null && inhomesss.local_service.clinic.detail !== undefined ? inhomesss.local_service.clinic.detail : '',
        },
        other_service: {
          status: 'local_service' in inhomesss && 'other_service' in inhomesss.local_service && 'status' in inhomesss.local_service.other_service && inhomesss.local_service.other_service.status !== '' && inhomesss.local_service.other_service.status !== null && inhomesss.local_service.other_service.status !== undefined ? inhomesss.local_service.other_service.status : '',
          title: 'local_service' in inhomesss && 'other_service' in inhomesss.local_service && 'title' in inhomesss.local_service.other_service && inhomesss.local_service.other_service.title !== '' && inhomesss.local_service.other_service.title !== null && inhomesss.local_service.other_service.title !== undefined ? inhomesss.local_service.other_service.title : '',
          detail: 'local_service' in inhomesss && 'other_service' in inhomesss.local_service && 'detail' in inhomesss.local_service.other_service && inhomesss.local_service.other_service.detail !== '' && inhomesss.local_service.other_service.detail !== null && inhomesss.local_service.other_service.detail !== undefined ? inhomesss.local_service.other_service.detail : '',
        }
      }
      
      this.exercise_activity = 'exercise_activity' in inhomesss && inhomesss.exercise_activity !== '' && inhomesss.exercise_activity !== null && inhomesss.exercise_activity !== undefined ? inhomesss.exercise_activity : '',

      this.sleepy = {
        hours_sleep: 'sleepy' in inhomesss && 'hours_sleep' in inhomesss.sleepy && inhomesss.sleepy.hours_sleep !== '' && inhomesss.sleepy.hours_sleep !== null && inhomesss.sleepy.hours_sleep !== undefined ? inhomesss.sleepy.hours_sleep : '',
        sleep_problem: {
          status: 'sleepy' in inhomesss && 'sleep_problem' in inhomesss.sleepy && 'status' in inhomesss.sleepy.sleep_problem && inhomesss.sleepy.sleep_problem.status !== '' && inhomesss.sleepy.sleep_problem.status !== null && inhomesss.sleepy.sleep_problem.status !== undefined ? inhomesss.sleepy.sleep_problem.status : '',
          title: 'sleepy' in inhomesss && 'sleep_problem' in inhomesss.sleepy && 'title' in inhomesss.sleepy.sleep_problem && inhomesss.sleepy.sleep_problem.title !== '' && inhomesss.sleepy.sleep_problem.title !== null && inhomesss.sleepy.sleep_problem.title !== undefined ? inhomesss.sleepy.sleep_problem.title : '',
          detail: 'sleepy' in inhomesss && 'sleep_problem' in inhomesss.sleepy && 'detail' in inhomesss.sleepy.sleep_problem && inhomesss.sleepy.sleep_problem.detail !== '' && inhomesss.sleepy.sleep_problem.detail !== null && inhomesss.sleepy.sleep_problem.detail !== undefined ? inhomesss.sleepy.sleep_problem.detail : '',
        }
      }
    },
  }
}
</script>

<style scoped>
.card-border-title {
  border-right: 2px solid #00A99D;
}
.card-border-title-phone {
  border-bottom: 2px solid #00A99D;
}
.card-border {
  border-top: 2px solid #00A99D;
  border-left: 2px solid #00A99D;
  border-right: 2px solid #00A99D;
}
.card-border-end {
  border-bottom: 2px solid #00A99D;
}
.card-none-shadow {
  box-shadow: 0px 0px 0px 0px !important;
}
::v-deep .v-input--selection-controls__input + .v-label {
  font-size: 16px !important;
  color: #333333 !important;
}
</style>